import { CircleAlert } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/shared/components/ui/Button';

interface ModalAddAmbulanceProps {
  isOpen?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}

const ModalAddAmbulance = ({ isOpen, onClose, onConfirm }: ModalAddAmbulanceProps) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[1000]">
      <div className="w-[30%] p-6 flex flex-col gap-3 bg-db-card border bg-db-border rounded-[5px] overflow-hidden">
        <div className="w-full flex flex-row gap-3 items-center">
          {/* Same rounded-square, 10%-opacity-tint convention as the other
              modals' icon assets (see report-icon.svg / reject-icon.svg) -
              built inline since no dedicated asset exists for this action. */}
          <div className="shrink-0 size-[66px] rounded-[12px] bg-[#007AFF]/10 flex items-center justify-center">
            <CircleAlert color="#007AFF" size={28} />
          </div>
          <div className="flex flex-col">
            <span className="h5bold">{t('dispatch>modal>add ambulance title')}</span>
            <span className="title2 text-db-text-grey">
              {t('dispatch>modal>add ambulance description')}
            </span>
          </div>
        </div>

        <div className="w-full inline-flex gap-3 items-center bg-text-danger-300 p-3 rounded-[4px]">
          <CircleAlert color="#ed3131" className="shrink-0" />
          <span className="title2 text-text-grey italic">
            {t('dispatch>modal>add ambulance victims warning')}
          </span>
        </div>

        <div className="w-full flex justify-center pb-2 items-center m-auto gap-3">
          <Button
            bg-text-danger-300
            className="flex-1 btn-fill-red-ghost text-[20px] cursor-pointer"
            label={t('cmn>master>cancel')}
            onClick={onClose}
          />
          <Button
            bg-text-danger-300
            className="flex-1 btn-fill-blue text-[20px] cursor-pointer"
            label={t('dispatch>modal>continue')}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalAddAmbulance;
